import React, { createContext, useState, useEffect } from "react";

// Create the context
export const AuthContext = createContext();

// Auth Provider to manage state
export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    //######################################################test
    // const [user, setUser] = useState({
    //     userName: "cash1",
    //     userRole: "cashier",
    // }); //######################################################test
    const [userReady, setUserReady] = useState(false);

    // Check if user session exists in localStorage
    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
        setUserReady(true);
    }, []);

    // Function to authenticate user
    const login = (userData) => {
        localStorage.setItem("user", JSON.stringify(userData)); // Persist the user in localStorage
        setUser(userData);
    };

    // Function to logout
    const logout = () => {
        localStorage.removeItem("user");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, userReady }}>
            {children}
        </AuthContext.Provider>
    );
};
export default AuthContext;
